import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DistrictEntity } from '../../domain/entities/DistrictEntity'
import { RegionDistrictModel } from './RegionDistrictModel'
import type { GetDistrictsByRegionAdminResponse } from '@/backend/market'
export class DistrictModel extends DistrictEntity {
  constructor(dataDto: GetDistrictsByRegionAdminResponse) {
    super()
    dataDto.districts = dataDto.districts?.map((district) => {
      district.boundary?.pop()
      return {
        ...district
      }
    })
    const regionDistrictModels = dataDto.districts?.map(
      (district) => new RegionDistrictModel(district)
    )
    mapEntityProperties<DistrictEntity>(this, dataDto, {
      map: {
        districts: regionDistrictModels
      }
    })
  }
}
